export const CoursesCategoryData = [
    {
        name: 'Web Design',
        index: 'collapseOne',
    },
    {
        name: 'Web Development',
        index: 'collapseTwo',
    },
    {
        name: 'Graphics Design',
        index: 'collapseThree',
    },
    {
        name: 'Spoken English',
        index: 'collapseFour',
    },
    {
        name: 'Others',
        index: 'collapseFive',
    },
]